import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import Img from "../gatsbyImage/gatsbyImage"
import { device } from "../mediaQuery/mediaQuery"
const iconImg = [
  // {
  //   id: "1",
  //   filename: `socialMedia/facebook-icon.png`,
  //   alt: `Facebook Icon`,
  //   link: `/`,
  // },
  // {
  //   id: "2",
  //   filename: `socialMedia/line-icon.png`,
  //   alt: `Line Icon`,
  //   link: `/`,
  // },
  {
    id: "3",
    filename: `socialMedia/linkedin-icon.png`,
    alt: `LinkedIn Icon`,
    link: `https://www.linkedin.com/in/%E6%9F%8F%E4%BB%81-%E9%99%B3-189201138/`,
  },
  {
    id: "4",
    filename: `socialMedia/github-icon.png`,
    alt: `github Icon`,
    link: `https://github.com/DomingoChen`,
  },
 
]

const footer = ({ siteTitle, description, author }) => {
  return (
    <Container id={`footer`}>
      <Wrap>
        <Area>
          <Title>{siteTitle}</Title>

          <SubTitle>{description}</SubTitle>
          <Icons>
            {iconImg.map(({ id, filename, alt, link }) => (
              <IconLink to={link} key={id}>
                <Img filename={filename} alt={alt} />
              </IconLink>
            ))}
          </Icons>
          <Copyright>
            {`Copyright © ${new Date().getFullYear()} ${author} All rights reserved`}
          </Copyright>
        </Area>
        <Area></Area>
        <Area></Area>
      </Wrap>
    </Container>
  )
}
const Container = styled.footer`
  background-color: #071f35;
`
const Wrap = styled.div`
  max-width: 1280px;
  padding: 40px 20px;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${device.tablet} {
    flex-direction: column;
  }
  @media ${device.desktop} {
  }
`
const Area = styled.div`
  color: white;
  @media ${device.tablet} {
    width: 100%;
    padding-left: 20px;
  }
  @media ${device.desktop} {
    width: 33.33%;
  }
`

const Title = styled.p`
  font-size: 32px;
  margin-bottom: 10px;
`
const SubTitle = styled.p`
  font-size: 24px;
  margin-bottom: 10px;
`
const Icons = styled.div`
  display: flex;
  margin-bottom: 10px;
`

const IconLink = styled(Link)`
  width: 40px;
  height: 40px;

  :not(:last-child) {
    margin-right: 10px;
  }
`

const Copyright = styled.p`
  font-size: 18px;
`
export default footer
